import { useContext } from "react";
import { digitsThree } from "../../../utils/price";
import { context } from "../../../context/context";

function GuarantorAllInfo({ data }) {
  const { utils } = useContext(context);
  return (
    <div>
      <h3>اطلاعات ضامنین</h3>

      {data?.loanGuarantors?.length
        ? data?.loanGuarantors.map((item) => {
            return (
              <>
                <h4 className="mt-4">مشخصات</h4>
                <div className="flex flex-col gap-3 text-gray-500 py-4">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <p className="w-full text-center sm:text-right">
                      نام ضامن : {item?.name || "-"}
                    </p>
                    <p className="w-full text-center sm:text-right">
                      کد ملی : {item?.nationalId || "-"}
                    </p>
                    <p className="w-full text-center sm:text-right">
                      موبایل : {item?.mobile || "-"}
                    </p>
                    <p className="w-full text-center sm:text-right">
                      شماره حساب : {item?.bankAccountId || "-"}
                    </p>
                    <p className="w-full text-center sm:text-right">
                      وضعیت :{" "}
                      {utils?.LOAN_GUARANTOR_STATUS?.[item?.status]?.name ||
                        "-"}
                    </p>
                  </div>
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <p className="w-full text-center sm:text-right">
                      توضیحات شغلی : {item?.jobDescription || "-"}
                    </p>
                  </div>
                </div>

                <h4>اعتبار سنجی</h4>
                <div className="flex flex-col gap-3 text-gray-500 py-4">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <p className="w-full text-center sm:text-right">
                      مانده سقف ضمانت :{" "}
                      {digitsThree(item?.remainingGuaranteeLimit) || "-"}
                    </p>
                    <p className="w-full text-center sm:text-right">
                      مبلغ سفته : {digitsThree(item?.promissoryNote) || "-"}
                    </p>
                  </div>
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <p className="w-full text-center sm:text-right">
                      وضعیت اعتبار سنجی :{" "}
                      {utils?.CREDIT_TYPE?.[item?.creditType]?.name || "-"}
                    </p>
                  </div>
                </div>
                {data?.loanGuarantors?.length > 1 && (
                  <span className="w-6/12 mx-auto h-[2px] bg-gray-500 rounded-xl block mt-4 mb-6"></span>
                )}
              </>
            );
          })
        : null}
    </div>
  );
}

export default GuarantorAllInfo;
